import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { animateScroll, scroller } from "react-scroll";
import { splitLocalePath } from "@thyra/landing-i18n";

const HOME_ANCHOR_IDS = new Set(["home", "product", "pricing", "faq"]);
const SECTION_SCROLL_OPTIONS = { smooth: true, duration: 650, offset: -88 };

/**
 * On route change: scroll to top, or when navigating to home with a hash
 * (e.g. /#pricing from Contact), scroll to that section after the page has rendered.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const hashId = hash ? hash.replace(/^#/, "") : "";

    const isHome = splitLocalePath(pathname).path === "/";
    if (isHome && hashId && HOME_ANCHOR_IDS.has(hashId)) {
      const t = setTimeout(
        () => scroller.scrollTo(hashId, SECTION_SCROLL_OPTIONS),
        120,
      );
      return () => clearTimeout(t);
    }

    animateScroll.scrollToTop({ smooth: true, duration: 400 });
  }, [pathname, hash]);

  return null;
}
